"use client";

import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { type ReactNode, useState } from "react";

function logQueryError(scope: "cache" | "mutation", error: unknown) {
  if (typeof console !== "undefined") {
    console.error(`[react-query:${scope}]`, error);
  }
}

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            staleTime: 300_000,
            gcTime: 600_000,
            // Auth-gated SaaS: alt-tab/window-focus should not trigger a
            // refetch storm. Per-query override possible.
            refetchOnWindowFocus: false,
            refetchOnReconnect: "always",
            placeholderData: (prev: unknown) => prev,
          },
          mutations: {
            retry: 0,
          },
        },
        queryCache: new QueryCache({
          onError: (error) => logQueryError("cache", error),
        }),
        mutationCache: new MutationCache({
          onError: (error) => logQueryError("mutation", error),
        }),
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
